/**
 * Handing a file to the browser. One mechanism, used by everything that
 * downloads: the readiness record PDF (utils/reportPdf.web.ts) and the
 * plan's needs list (utils/planNeedsCsv.ts).
 *
 * It used to live privately inside reportPdf.web.ts. Pulled out when the
 * CSV export landed, so there is one place that knows about the revoke
 * delay below rather than two that have to agree about it.
 */
export function isDownloadSupported(): boolean {
  return typeof document !== 'undefined' && typeof URL?.createObjectURL === 'function';
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoked after a delay, not immediately: some browsers start the save
  // asynchronously and drop a URL revoked out from under it.
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/**
 * A text file, with a BOM so Excel opens UTF-8 CSV as UTF-8 rather than
 * mangling anything that is not ASCII. Without it, an address with an
 * accent in it arrives as mojibake on a Windows machine, which is exactly
 * where these spreadsheets get opened.
 */
export function downloadText(text: string, filename: string, mimeType: string): void {
  const blob = new Blob(['﻿', text], { type: `${mimeType};charset=utf-8` });
  triggerDownload(blob, filename);
}
